import React, { useEffect } from "react";
import { Box, LinearProgress, makeStyles, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";
import { actionTypes } from "../../../../../../redux/bourse/select_instruments";
import { useDispatch, useSelector } from "react-redux";
import { columns } from "./thead";
import ThbodyCustom from './thBody';
import { dateMiladiToShamsi } from "../../../../../method/date";


let useStyles = makeStyles((theme) => ({

}))




export default function Index({ state, page, setPage, rowsPerPage, flegApi  ,stock , setStock}) {

    let classes = useStyles();
    let dispatch = useDispatch();

    const stateReducer = useSelector((state) => state.bourse_select_instruments_reducer);


    const apiCallInstruments = () => {
        // let { size } = stateReducer;
        let size = 5
        let obj = {};
        let from = page;

        Object.keys(state).forEach((element) => {
            if (state[element]) {
                obj[element] = state[element]?.['code'] ? state[element]?.['code'] : state[element];
            }
        });

        if(obj?.from_date){
            obj = {
                ...obj,
                from_date : dateMiladiToShamsi(obj?.from_date?.split(' ')?.[0])
            }
        }

        if(obj?.to_date){
            obj = {
                ...obj,
                to_date : dateMiladiToShamsi(obj?.to_date?.split(' ')?.[0])
            }
        }

        if(obj?.commodity_id){
            obj = {
                ...obj,
                commodity_id : +obj?.commodity_id?.id
            }
        }

        let data = {...obj , currency_id:2 };

        dispatch({
            type: actionTypes.selectInstrumentsAsync,
            payload: { data, size, from },
        });
    };

    useEffect(() => {
        apiCallInstruments()
    }, [page, flegApi]);

    useEffect(() => {
        return () => {
          dispatch({
              type: actionTypes.selectInstrumentsEmpty,
          });
        };
      }, []);
      
    const changePage = (event, newPage) => {
        setPage(newPage);
    };


    const handleLink = (text) => {
        return <div>پیوست</div>
    };

    return (
        <div className={classes['root']}>
            <div style={{ height: 5, width: "100%", transform: "translateY(-5px)" }}>
                {stateReducer.loading && (
                    <LinearProgress style={{ width: "100%", color: "#009A44" }} />
                )}
            </div>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column, ind) => (
                                    <TableCell
                                        key={ind}
                                        align="center"
                                        style={{ width: 160, fontWeight: "bold" }}
                                        className="target"
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stateReducer?.data?.map((info, index) => (
                                <ThbodyCustom
                                    key={index}
                                    index={index}
                                    info={info}
                                    handleLink={handleLink}
                                    stock={stock}
                                    setStock={setStock}
                                />
                            ))}
                        </TableBody>
                    </Table>
                    {stateReducer?.data?.lenght === 0 && (
                        <div className={classes.noData}>دیتایی برای نمایش وجو ندارد</div>
                    )}
                </TableContainer>

                <Box dir="rtl" display="inline-block">
                    <TablePagination
                        component="div"
                        count={stateReducer.total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={changePage}
                        rowsPerPageOptions={true}
                        row
                        labelRowsPerPage="تعداد نمایش سطر"
                    />
                </Box>
            </Paper>
        </div>)
}
